import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { from } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { RequestsServices } from './requests.service';

// Saldo da carteira (GET /api/wallet, o mesmo endpoint do portal). O header-menu é recriado a cada
// página: o último saldo carregado fica guardado com a conta dona dele, para o menu começar desse
// valor em vez de "—". Outra conta logada começa sem saldo.
@Injectable()
export class WalletService {
  private lastKnownBalance: { accountId: string; availableBalance: number } = null;

  constructor(public request: RequestsServices) {}

  cachedBalanceFor(accountId: string): number | null {
    if (!accountId || !this.lastKnownBalance || this.lastKnownBalance.accountId !== accountId) {
      return null;
    }
    return this.lastKnownBalance.availableBalance;
  }

  getBalance(accountId: string): Observable<number> {
    return from(this.request.get({ path: 'wallet' })).pipe(
      // Igual ao portal (`availableBalance ?? 0`): sem saldo na resposta, 0.
      map((data: any) => {
        const availableBalance = Number(data && data.availableBalance);
        return isFinite(availableBalance) ? availableBalance : 0;
      }),
      tap((availableBalance) => {
        if (accountId) {
          this.lastKnownBalance = { accountId, availableBalance };
        }
      })
    );
  }
}
